import api from "./index";

export interface ExpulsionOrdersListParam {
  listenersIds?: Array<string>;
  courseIds?: Array<string>;
  number?: string;
  companyId?: string;
  ownerId?: string;
  contractorId?: string;
  formedAtMin?: Date;
  formedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  signedAt?: boolean;
  signedAtMin?: Date;
  signedAtMax?: Date;
  educationStartedAtMin?: Date;
  educationStartedAtMax?: Date;
  educationFinishedAtMin?: Date;
  educationFinishedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "updatedAt" | "signedAt" | "formedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: ExpulsionOrdersListParam) => {
  return api.ExpulsionOrderApi.listShort(
    params.listenersIds,
    params.courseIds,
    params.number,
    params.companyId,
    params.ownerId,
    params.contractorId,
    params.formedAtMin,
    params.formedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.signedAt,
    params.signedAtMin,
    params.signedAtMax,
    params.educationStartedAtMin,
    params.educationStartedAtMax,
    params.educationFinishedAtMin,
    params.educationFinishedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
